import { $t } from "@/plugins/i18n";

import { useHotelStoreHook } from "../../store/hotel";
export default [
  {
    path: "/hotel/prepareOrder",
    name: "prepareOrder",
    component: () => import("../../views/hotel/prepareOrder/index.vue"),
    meta: {
      title: $t("shell.breadcrumb.submitOrder"),
      requireLogin: true,
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/hotel/list",
    name: "hotelList",
    component: () => import("../../views/hotel/List/index.vue"),
    meta: {
      title: $t("shell.breadcrumb.hotelList"),
      showLink: false,
      rank: 101,
      keepAlive: true,
      beforeEnter: query => {
        if (!query) {
          return;
        }
        useHotelStoreHook().initHotelQuery(query);
      }
    }
  },
  {
    path: "/hotel/detail",
    name: "hotelDetail",
    component: () => import("../../views/hotel/Detail/index.vue"),
    meta: {
      title: $t("shell.breadcrumb.hotelDetail"),
      showLink: false,
      rank: 101,
      keepAlive: true,
      beforeEnter: query => {
        if (!query) {
          return;
        }
        useHotelStoreHook().initHotelQuery(query);
      }
    }
  }
];
